import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { CommonService } from "../../common.service";
import { DatePipe } from "@angular/common";
import * as XLSX from "xlsx";
import { CommonVariablesService } from "../../common-variables.service";

@Component({
	selector: "app-incomplete-to-completelisterrorlog",
	templateUrl: "./incomplete-to-completelisterrorlog.component.html",
})
export class IncompleteToCompletelisterrorlogComponent implements OnInit {
	incompleteToCompleteListErrorLogForm: FormGroup;
	systemDate: any;
	dtTrigger: Subject<any> = new Subject();
	dtOptions: any;
	displayIncompleteToCompleteListErrorLog: any = [];
	submitted = false;
	getsystemDate: any;
	//getFromDate:any;
	fromDate: any;
	toDate: any;
	sendFromDate: any;
	sendToDate: any;

	constructor(
		private formBuilder: FormBuilder,
		private commonService: CommonService,
		private commonVariablesService: CommonVariablesService,
		private datePipe: DatePipe
	) {}

	ngOnInit(): void {
		window.localStorage.setItem("pageName", "");
		$("#divIncompleteToCompleteListErrorLog").hide();
		$("#btnIncompleteToCompleteErrorLogExcelDownload").hide();

		this.incompleteToCompleteListErrorLogForm = this.formBuilder.group({
			selectFromDate: ["", Validators.required],
			selectToDate: ["", Validators.required],
		});

		this.dtOptions = {
			dom: "frtip",
			pageLength: 50,
		};
		this.getsystemDate = new Date();
		/*let getDate =new Date(this.getsystemDate);
    getDate.setMonth(getDate.getMonth()-1);
    this.getFromDate=getDate;
    
    this.incompleteToCompleteListErrorLogForm.patchValue({
      selectFromDate: this.getFromDate,
      selectToDate: this.getsystemDate,
      });*/

		this.systemDate = this.datePipe.transform(this.getsystemDate, "yyyy-MM-dd");
	}
	get f() {
		return this.incompleteToCompleteListErrorLogForm.controls;
	}

	/*
	 * Created By : Keerthana
	 * Description : This function will submit the data.
	 *********************************************/

	async submitDate() {
		if (this.incompleteToCompleteListErrorLogForm.invalid) {
			this.submitted = true;
			return;
		} else {
			this.fromDate = this.datePipe.transform(
				this.incompleteToCompleteListErrorLogForm.value.selectFromDate
			);
			this.toDate = this.datePipe.transform(
				this.incompleteToCompleteListErrorLogForm.value.selectToDate
			);

			if (new Date(this.toDate) < new Date(this.fromDate)) {
				this.commonService.errorsmsg(
					"From date should be less than to date",
					"Error"
				);
			} else {
				/*else if(new Date(this.toDate)>new Date(this.systemDate))
    {
      this.commonService.errorsmsg("To date should not be greater than system date","Error");
    }*/
				this.sendFromDate = this.datePipe.transform(
					this.fromDate,
					"yyyy-MM-dd"
				);
				this.sendToDate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
				$(
					"#searchGCPolicyNumber,#searchReferenceNumber,#searchInsillionPolicyId,#searchDescription,#searchDate,#searchSME"
				).val("");
				let table = $("#incompleteToCompleteListErrorLogDataTable").DataTable();
				table.destroy();
				let fetchUrl =
					this.commonVariablesService.baseURL +
					"api/v1/marine_report/fetch_incomplete_to_complete_error_log?from_date=" +
					this.sendFromDate +
					"&to_date=" +
					this.sendToDate +
					"";
				let tblData = await this.commonService.httpGetMethod(
					fetchUrl,
					"",
					true,
					"",
					"Incomplete To Complete List Error Log"
				);
				this.displayIncompleteToCompleteListErrorLog = [];
				if (tblData.status == 0) {
					if (tblData.data.length > 0) {
						for (var i = 0; i < tblData.data.length; i++) {
							this.displayIncompleteToCompleteListErrorLog.push(
								tblData.data[i]
							);
						}
					} else {
						this.displayIncompleteToCompleteListErrorLog = [];
					}
				} else if (tblData.status != -114) {
					this.commonService.errorsmsg("Fetch Error: " + tblData.txt, "Error");
				}

				this.dtTrigger.next();

				$("#divIncompleteToCompleteListErrorLog").show();
				$("#btnIncompleteToCompleteErrorLogExcelDownload").show();
			}
		}
	}

	/*
	 * Created By : Keerthana
	 * Description : This function is used to download the excel file.
	 *********************************************/

	exportExcel() {
		if (this.displayIncompleteToCompleteListErrorLog.length > 0) {
			var datajson = {
				datajson1: this.displayIncompleteToCompleteListErrorLog,
			};

			var Heading = [
				[],
				["Incomplete To Complete List Error Log"],
				[],
				[
					"From Date",
					this.datePipe.transform(
						this.incompleteToCompleteListErrorLogForm.value.selectFromDate,
						"dd-MM-yyyy"
					) || "",
				],
				[
					"To Date",
					this.datePipe.transform(
						this.incompleteToCompleteListErrorLogForm.value.selectToDate,
						"dd-MM-yyyy"
					) || "",
				],
				[],
				[
					"GC Policy Number",
					"Reference number",
					"Insillion Policy Id",
					"Description",
					"Date",
					"SME",
				],
			];

			const merge = [
				{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } },
				{ s: { r: 1, c: 0 }, e: { r: 1, c: 7 } },
				{ s: { r: 2, c: 0 }, e: { r: 2, c: 7 } },
				{ s: { r: 3, c: 0 }, e: { r: 3, c: 7 } },
				{ s: { r: 6, c: 0 }, e: { r: 6, c: 7 } },
			];
			var wscols = [];
			//let cell;
			for (let i = 0; i < Heading[6].length; i++) {
				wscols.push({ wch: 20 }); // Common column width
			}
			var ws = XLSX.utils.json_to_sheet(Heading);
			ws["!cols"] = wscols;
			ws["!merges"] = merge;
			ws["A1"] = {
				t: "s",
				/* "v": 'TATA MARINE', */
				s: {
					font: {
						size: 20,
						bold: true,
						color: "#e012e0",
						style: "text-align:center",
					},
				},
			};
			XLSX.utils.sheet_add_json(ws, datajson.datajson1, {
				header: [
					"gc_policy_number",
					"reference_number",
					"insillion_policy_id",
					"description",
					"ts",
					"SME",
				],
				skipHeader: true,
				origin: -1,
			});
			// var alphabets = [''];
			var wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "Incomplete to complete Errorlog");
			XLSX.writeFile(wb, "Incomplete_to_completelistErrorlog.xlsx");
		} else {
			this.commonService.errorsmsg(
				"Unable to download excel,No data available in the table",
				"Error"
			);
		}
	}

	/*
	 * Created By : Keerthana
	 * Description : This function will filter datatable according to search.
	 *********************************************/

	filterBySearch() {
		let searchGCPolicyNumber = $("#searchGCPolicyNumber")
			.val()
			.toString()
			.toLowerCase();
		let searchReferenceNumber = $("#searchReferenceNumber")
			.val()
			.toString()
			.toLowerCase();
		let searchInsillionPolicyId = $("#searchInsillionPolicyId")
			.val()
			.toString()
			.toLowerCase();
		let searchDescription = $("#searchDescription")
			.val()
			.toString()
			.toLowerCase();
		let searchDate = $("#searchDate").val().toString().toLowerCase();
		let searchSme = $("#searchSme").val().toString().toLowerCase();

		let table = $("#incompleteToCompleteListErrorLogDataTable").DataTable();
		table.search("").columns().search("").draw();
		if (searchGCPolicyNumber != "") {
			table.column(0).search(searchGCPolicyNumber).draw();
		}
		if (searchReferenceNumber != "") {
			table.column(1).search(searchReferenceNumber).draw();
		}
		if (searchInsillionPolicyId != "") {
			table.column(2).search(searchInsillionPolicyId).draw();
		}
		if (searchDescription != "") {
			table.column(3).search(searchDescription).draw();
		}
		if (searchDate != "") {
			table.column(4).search(searchDate).draw();
		}
		if (searchSme != "") {
			table.column(5).search(searchSme).draw();
		}
	}
}
